import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
const useStyles = makeStyles({
    paneRootDiv: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        padding: `0 ${tokens.spacingHorizontalM}`,
    },
});
/**
 * Used to apply common styles to panes.
 */
export const SidePaneContainer = forwardRef((props, ref) => {
    const { className, ...rest } = props;
    const classes = useStyles();
    return (_jsx("div", { className: mergeClasses(classes.paneRootDiv, className), ref: ref, ...rest, children: props.children }));
});
//# sourceMappingURL=pane.js.map